import { convertKeysToCamelCase } from 'helpers/convertKeysToCamelCase'
import { formatPersonDateFieldsForEps } from 'helpers/formatPersonDateFieldsForEps'

export function preparePersonForEpsPost(person) {
  const formatted = formatPersonDateFieldsForEps(person)
  const camelCasePerson = convertKeysToCamelCase(formatted)
  return formatPersonDateFieldsForEps(camelCasePerson)
}
